import React from 'react';
import Title from '../../atoms/title/title.js';
import Avatar from '../avatar/avatar.js';

const ChatBubble = ({ message, isUser, time, avatarSrc = null }) => {
    const now = new Date(time);
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    const formattedHours = hours12.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const timeOnBubble = `${formattedHours}:${formattedMinutes} ${ampm}`;
    return (React.createElement("div", { className: `mbw-chat-bubble-wrapper ${isUser ? "mbw-chat-bubble-wrapper-user" : "mbw-chat-bubble-wrapper-other"}` },
        !isUser && React.createElement("div", { className: "mbw-chat-bubble-avatar-container" },
            React.createElement(Avatar, { imgSrc: avatarSrc, type: "round", size: "small" })),
        React.createElement("div", { className: `mbw-chat-bubble ${isUser ? "mbw-chat-bubble-user" : "mbw-chat-bubble-other"}` },
            React.createElement("div", { className: "mbw-chat-bubble-message" },
                React.createElement(Title, { fontStyle: "content-medium" }, message),
                React.createElement("div", { className: "mbw-chat-bubble-time" },
                    React.createElement(Title, { fontStyle: "caption-2" }, timeOnBubble))))));
};

export { ChatBubble as default };
//# sourceMappingURL=chat-bubble.js.map
